import { objectToSnakeCase, objectToCamelCase } from '../utils'

import api from './api'

export default class Update {
  static api = api.create(Update)
  static readOnlyFields = ['id']

  constructor({
    id = null,
    datetimeCreated = '',
    lastEdited = '',
    title = '',
    description = '',
    project = '',
    projectRef = {},
    date = '',
    photos = [],
  } = {}) {
    Object.assign(this, {
      id,
      datetimeCreated,
      lastEdited,
      title,
      description,
      project,
      projectRef,
      date,
      photos,
    })
  }

  copy() {
    return new Update(this)
  }

  update(data = {}) {
    return Object.assign(this.copy(), data)
  }

  static create(data = {}) {
    return new Update(data)
  }

  static fromAPI(json = {}) {
    const jsonCamel = objectToCamelCase(json)
    return new Update(jsonCamel)
  }
  /**
   *  Prep Update data for the API. Can elect to include
   *  or exlude specific fields. The `Update.readOnlyFields`
   *  are always excluded.
   **/
  static toAPI(update, fields = [], excludeFields = []) {
    // By default, send the whole update
    let data = {}

    // If it's a partial update, get only the fields specified
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = update[field]
      })
    } else {
      data = update
    }

    excludeFields = [...Update.readOnlyFields, ...excludeFields]
    excludeFields.forEach(item => {
      delete data[item]
    })

    return objectToSnakeCase(data)
  }

  static checkIsInstance(obj, name) {
    if (!(obj instanceof Update)) {
      throw Error(`${name} must be an instance of the Update class.`)
    }
  }
}
